import React from 'react';

import { CanvasPolygons } from '@paragon/client-tools';

import { getMemberVertices } from '../../store/selectors/componentPreviewSelectors';
import { getCommittedComponentDesigns } from '../../store/selectors/getComponentDesignsSelectors';
import { useAppSelector } from '../hooks';

interface Props {
  readonly componentDesignGuid: string;

  readonly color?: string;

  readonly maxWidth: number;
  readonly maxHeight: number;
}

// TODO: merge with Scotty's version once that's finished and move to a library

export function ComponentPreview(props: Props) {
  const { componentDesignGuid, maxWidth, maxHeight } = props;

  const componentDesigns = useAppSelector(getCommittedComponentDesigns);
  const componentDesign = componentDesigns.find((design) => design.guid === componentDesignGuid);
  const component = componentDesign ? componentDesign.component : null;

  const memberVertices = useAppSelector((state) => getMemberVertices(state, componentDesignGuid));

  if (!component || !memberVertices) return null;

  return (
    <CanvasPolygons shapes={memberVertices} color={props.color ?? 'orange'} maxWidth={maxWidth} maxHeight={maxHeight} />
  );
}
